import { render, staticRenderFns } from "./UsersIcon.vue?vue&type=template&id=61649b05"
import script from "./UsersIcon.vue?vue&type=script&lang=js"
export * from "./UsersIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports